export default class Supplier {

    constructor(id, supp_name, supp_no, common) 
    {
      this.id = id;
      this.supp_name = supp_name;
      this.supp_no = supp_no;
      this.common = common;  
    }     
}


// WEBPACK FOOTER //
// ./src/assets/js/Supplier.js